
export { TokenParticipationAmount } from "/home/runner/work/capsicum/capsicum/libs/socios-core/web/partners/ui/token-participation-amount/TokenParticipationAmount.tsx"